import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { NotifEvent } from '@/types';

const MAX_EVENTS = 100;

interface NotificationsState {
  events: NotifEvent[];
  addEvent: (event: NotifEvent) => void;
  clear: () => void;
  unreadCount: number;
  markAllRead: () => void;
}

export const useNotificationsStore = create<NotificationsState>()(
  persist(
    (set, get) => ({
      events: [],
      unreadCount: 0,

      addEvent: (event) => {
        // Evita duplicar o mesmo evento (mesmo id)
        if (get().events.some((e) => e.id === event.id)) return;
        set((s) => ({
          events: [event, ...s.events].slice(0, MAX_EVENTS),
          unreadCount: s.unreadCount + 1,
        }));
      },

      clear: () => set({ events: [], unreadCount: 0 }),

      markAllRead: () => set({ unreadCount: 0 }),
    }),
    {
      name: 'sports-notifications',
      storage: createJSONStorage(() => AsyncStorage),
      // Não persiste unreadCount (zera a cada sessão)
      partialize: (state) => ({ events: state.events }),
    }
  )
);

// Acesso fora de componentes React (ex: livePoller)
export const notificationsStore = {
  add(event: NotifEvent) {
    useNotificationsStore.getState().addEvent(event);
  },
};
